// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2UzLM","title":"AfterBackImages_title__3CUEm","images":"AfterBackImages_images___4_K_"};